import script from "./dropdown-menu.vue?vue&type=script&lang=ts&setup=true"
export * from "./dropdown-menu.vue?vue&type=script&lang=ts&setup=true"

import "./dropdown-menu.vue?vue&type=style&index=0&id=3c0902e2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c0902e2"]])

export default __exports__